<template>
  <div class="shop home__section container">
    <div class="shop-info">
      <h1 class="shop__title">{{ $t('headers.shop') }}</h1>
      <div class="shop__desc">{{ $t('descriptions.shop') }}</div>
      <h2 class="shop__title--small">{{ $t('headers.browse') }}</h2>
      <a
        v-for="(category, index) in shopCategories"
        :key="index"
        :href="`https://shop.bandwagon.asia/collections/${category.handle}`"
        target="_blank"
        class="category-link"
      >
        <div
          class="category-link__image"
          :style="{ 'background-image': `url(${category.image.src})`}"
        />
        <span class="category-link__name">{{ category.title }}</span>
      </a>
      <span class="shop__link">
        <a href="https://shop.bandwagon.asia" target="_blank">{{ $t('buttons.view-all') }}</a>
      </span>
    </div>
    <div class="shop-products">
      <div class="shop-products-list">
        <div
          v-for="(product, index) in shopProductsInView"
          :key="index"
          class="shop-product"
        >
          <img
            class="shop-product__image"
            :src="product.image.src"
          >
          <div class="shop-product__name">{{ product.title }}</div>
          <a
            :href="`https://shop.bandwagon.asia/products/${product.handle}`"
            target="_blank"
            class="shop-product__link button button--primary button--small"
          >{{ $t("buttons.buy-now").toUpperCase() }}</a>
        </div>
      </div>
      <div class="shop-navigation">
        <i
          class="arrow left"
          :class="{disabled: productIndex <= 2}"
          @click="() => { productIndex > 2 && navigateshop(-2) }"
        />
        <i
          class="arrow right"
          :class="{disabled: productIndex >= shopProducts.length}"
          @click="() => { productIndex < shopProducts.length && navigateshop(2) }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shopProducts: {
      type: Array,
      default: () => [],
    },
    shopCategories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      productIndex: 2,
    };
  },
  computed: {
    shopProductsInView() { return this.shopProducts.slice(this.productIndex - 2, this.productIndex); },
  },
  methods: {
    navigateshop(increment) {
      this.productIndex += increment;
    },
  },
};
</script>
